export const industryCertificates = [
  {
    year: '2024',
    items: [
      {
        title: '海南师范大学物理与电子工程学院实习基地',
        image: '/images/certificate/hnsfdxwlydzgcxysxjd.jpg',
      },
    ],
  },
  {
    year: '2023',
    items: [
      {
        title: '2023年度老旧小区物业服务优秀项目',
        image: '/images/certificate/2023ndljxqwyfwyxxm.jpg',
      },
      {
        title: '琼海市物业管理行业协会战略合作单位',
        image: '/images/certificate/qhswyglhyxhzlhzdw.jpg',
      },
    ],
  },
  {
    year: '2022',
    items: [
      { title: '软件企业证书', image: '/images/certificate/rjqyzs.jpg' },
      {
        title: '海南省诚信企业协会会员单位',
        image: '/images/certificate/hnscxqyxhyydw.jpg',
      },
      {
        title: '海口市物业管理行业协会战略合作单位',
        image: '/images/certificate/hkswyglhyxhzlhzdw.jpg',
      },
    ],
  },
  {
    year: '2021',
    items: [
      {
        title: '2021年度房企物企数字化最佳服务企业',
        image: '/images/certificate/2021ndfqwqszhzjfwqy.jpg',
      },
    ],
  },
  {
    year: '2020',
    items: [
      //   { title: '高新技术企业', image: '/images/certificate/gxjsqy.jpg' },
      {
        title: '海南省物联网产业协会副理事长单位',
        image: '/images/certificate/hnswlcyshflszdw.jpg',
      },
      {
        title: '海南省物联网产业协会战略合作伙伴',
        image: '/images/certificate/hnswlcyshzlhzhb.jpg',
      },
    ],
  },
  {
    year: '2019',
    items: [
      { title: '软件产品证书', image: '/images/certificate/rjcpzs.jpg' },
      {
        title: '海口市业主委员会协会会员单位',
        image: '/images/certificate/hksyzwyxhhyydw.jpg',
      },
    ],
  },
]

export const patents = [
  {
    title: '一种服务器安全数据储存盘保护装置',
    id: 'ZL 2021 2 0954363.4',
    image: '/images/patents/yzfwqaqsjccpbhzz--hnzhckjyxgs2021209543634-1.jpg',
  },
  {
    title: '一种物业设备设施智能监控报警装置',
    id: 'ZL 2021 2 0954384.6',
    image: '/images/patents/yzgysbssznjkbjzz--hnzhckjyxgs2021209543846_01.jpg',
  },
  {
    title: '一种用于门禁识别的智能控制装置',
    id: 'ZL 2021 2 0954375.7',
    image: '/images/patents/yzyymjsbdznkzzz--hnzhckjyxgs2021209543757_01.jpg',
  },
  {
    title: '一种虚拟组网的视频监控摄像头',
    id: 'ZL 2021 2 0954379.5',
    image: '/images/patents/yzxnzwdspjksxt--hnzhckjyxgs2021209543795-1.jpg',
  },
  {
    title: '一种车辆过闸放行监测设备',
    id: 'ZL 2021 2 0954385.0',
    image: '/images/patents/yzclgzfxjcsb--hnzhckjyxgs2021209543850-1.jpg',
  },
]

export const softwareCopyrights = [
  {
    title: '智慧城新零售平台V1.0',
    id: '2023SR0001',
    image: '/images/copy-rights/zhcxlsptv1.0.jpg',
  },
  {
    title: '智慧城绘服务业主服务平台软件V1.0',
    id: '2023SR0002',
    image: '/images/copy-rights/zhchfwyzfwptrjv1.0.jpg',
  },
  {
    title: '智慧城绘管家手机APP软件V1.0',
    id: '2023SR0003',
    image: '/images/copy-rights/zhchgjsjapprjv1.0.jpg',
  },
  {
    title: '智慧城绘管家物业收费系统软件V1.0',
    id: '2023SR0004',
    image: '/images/copy-rights/zhchgjgysfxtrjv1.0.jpg',
  },
  {
    title: '沐恩YY铃声手机应用软件V1.0',
    id: '2023SR0005',
    image: '/images/copy-rights/meyylssjyyrjv1.0.jpg',
  },
  {
    title: '沐恩优客美食优惠券手机应用软件V1.0',
    id: '2023SR0006',
    image: '/images/copy-rights/meykmsyhqsjyyrjv1.0.jpg',
  },
  {
    title: '沐恩商城电商平台软件V1.0',
    id: '2023SR0007',
    image: '/images/copy-rights/mescdsptrjv1.0.jpg',
  },
  {
    title: '沐恩支付商家收款软件V1.0',
    id: '2023SR0008',
    image: '/images/copy-rights/mezfsjskrjv1.0.jpg',
  },
  {
    title: '沐恩智慧物业平台软件V1.0',
    id: '2023SR0009',
    image: '/images/copy-rights/mezhgyptrjv1.0.jpg',
  },
  {
    title: '海南省物业管理协会平台V1.0',
    id: '2023SR0010',
    image: '/images/copy-rights/hnsgyglxhptv1.0.jpg',
  },
  {
    title: '物业信息采集系统证书V1.0',
    id: '2023SR0011',
    image: '/images/copy-rights/gyxxcjxtssv1.0.jpg',
  },
  {
    title: '物业小区资产档案管理系统V1.0',
    id: '2023SR0012',
    image: '/images/copy-rights/gyxqzcdaglxtv1.0.jpg',
  },
  {
    title: '玉林市物业管理协会平台V1.0',
    id: '2023SR0013',
    image: '/images/copy-rights/ylsgyglxhptv1.0.jpg',
  },
  {
    title: '绘服务业主服务平台V2.0',
    id: '2023SR0014',
    image: '/images/copy-rights/hfwyzfwptv2.0.jpg',
  },
  {
    title: '绘服务公示公开系统 V1.0',
    id: '2023SR0015',
    image: '/images/copy-rights/hfwgsgkxtv1.0.jpg',
  },
  {
    title: '绘服务物业服务系统V1.0',
    id: '2023SR0016',
    image: '/images/copy-rights/hfwgyfwxtv1.0.jpg',
  },
  {
    title: '绘服务缴费系统V1.0',
    id: '2023SR0017',
    image: '/images/copy-rights/hfwjfxtv1.0.jpg',
  },
  {
    title: '绘管家任务管理系统V1.0',
    id: '2023SR0018',
    image: '/images/copy-rights/hgjrwglxtv1.0.jpg',
  },
  {
    title: '绘管家保洁管理系统V1.0',
    id: '2023SR0019',
    image: '/images/copy-rights/hgjbjglxtv1.0.jpg',
  },
  {
    title: '绘管家停车管理系统V1.0',
    id: '2023SR0020',
    image: '/images/copy-rights/hgjtcglxtv1.0.jpg',
  },
  {
    title: '绘管家办公自动化系统V1.0',
    id: '2023SR0021',
    image: '/images/copy-rights/hgjbgzdhxtv1.0.jpg',
  },
  {
    title: '绘管家安防巡更系统V1.0',
    id: '2023SR0022',
    image: '/images/copy-rights/hgjafxgxtv1.0.jpg',
  },
  {
    title: '绘管家投票表决平台V1.0',
    id: '2023SR0023',
    image: '/images/copy-rights/hgjtpbjptv1.0.jpg',
  },
  {
    title: '绘管家收费系统V2.0',
    id: '2023SR0024',
    image: '/images/copy-rights/hgjsfxtv2.0.jpg',
  },
  {
    title: '绘管家智慧管理数据大屏系统V1.0',
    id: '2023SR0025',
    image: '/images/copy-rights/hgjzhglsjdpxtv1.0.jpg',
  },
  {
    title: '绘管家智能水表管理系统V1.0',
    id: '2023SR0026',
    image: '/images/copy-rights/hgjznsbglxtv1.0.jpg',
  },
  {
    title: '绘管家智能电表管理系统V1.0',
    id: '2023SR0027',
    image: '/images/copy-rights/hgjzndbglxtv1.0.jpg',
  },
  {
    title: '绘管家智能门禁管理系统V1.0',
    id: '2023SR0028',
    image: '/images/copy-rights/hgjznmjglxtv1.0.jpg',
  },
  {
    title: '绘管家智能门禁系统V1.0',
    id: '2023SR0029',
    image: '/images/copy-rights/hgjznmjxtv1.0.jpg',
  },
  {
    title: '绘管家物业客服系统V1.0',
    id: '2023SR0030',
    image: '/images/copy-rights/hgjgykfxtv1.0.jpg',
  },
  {
    title: '绘管家物业综合管理云平台V1.0',
    id: '2023SR0031',
    image: '/images/copy-rights/hgjgyzhglyptv1.0.jpg',
  },
  {
    title: '绘管家设备管理系统V1.0',
    id: '2023SR0032',
    image: '/images/copy-rights/hgjsbglxtv1.0.jpg',
  },
  {
    title: '绘管家问卷调查系统V1.0',
    id: '2023SR0033',
    image: '/images/copy-rights/hgjwjdcxtv1.0.jpg',
  },
  {
    title: '设备巡检系统V1.0',
    id: '2023SR0034',
    image: '/images/copy-rights/sbxjxtv1.0.jpg',
  },
  {
    title: '远程抄表系统V1.0',
    id: '2023SR0035',
    image: '/images/copy-rights/yccbxtv1.0.jpg',
  },
]
